// POST ORDER
export const POST_ORDER_START = "POST_ORDER_START";
export const POST_ORDER_SUCESS = "POST_ORDER_SUCESS";
export const POST_ORDER_FAILURE = "POST_ORDER_FAILURE";

// DELETE THE ORDER ID FROM MY ORDER
export const DELETE_ORDER_GET_ID = "DELETE_ORDER_GET_ID";

// CANCEL THE POST MESSAGE POP UP MODEL
export const CANCLE_ORDER_MESSAGE = "CANCLE_ORDER_MESSAGE";

// CANCEL THE PUNCH IN POP UP MODEL
export const CANCLE_PUNCH_IN_MESSAGE = "CANCLE_PUNCH_IN_MESSAGE";

// CANCEL THE SERVED POP UP MODEL
export const CANCLE_SERVED_MESSAGE = "CANCLE_SERVED_MESSAGE";
//SHOW THE SERVED POP UP MODEL
export const SHOW_SERVED_MESSAGE = "SHOW_SERVED_MESSAGE";

//GET ORDER
export const GET_ORDER_START = "GET_ORDER_START";
export const GET_ORDER_SUCCESS = "GET_ORDER_SUCCESS";
export const GET_ORDER_FAILURE = "GET_ORDER_FAILURE";
//POST SERVE
export const POST_SERVE_START = "POST_SERVE_START";
export const POST_SERVE_SUCESS = "POST_SERVE_SUCESS";
export const POST_SERVE_FAILURE = "POST_SERVE_FAILURE";

//All ORDER OF THE DAY
export const GET_ALL_ORDER_START = "GET_ALL_ORDER_START";
export const GET_ALL_ORDER_SUCESS = "GET_ALL_ORDER_SUCESS";
export const GET_ALL_ORDER_FAILURE = "GET_ALL_ORDER_FAILURE";

//RECALL API FOR SHOW CHANGE
export const RECALL_API = "RECALL_API";

//RECALL ORDER API FOR SHOW CHANGE
export const RECALL_ORDER_API = "RECALL_ORDER_API";

//STORE ALL ORDER ID FOR SERVE ME
export const STORE_ALL_ORDER_ID = "STORE_ALL_ORDER_ID";
//STORE ORDER ID FOR SERVE ME
export const STORE_ORDER_ID = "STORE_ORDER_ID";
export const REMOVE_ORDER_ID = "REMOVE_ORDER_ID";

//RESER TOTAL AND SERVE ME IDS
export const RESET_ALL_TOTAL_AMOUNT = "RESET_ALL_TOTAL_AMOUNT";
export const RESET_ALL_ORDER_ID = "RESET_ALL_ORDER_ID";

//GRAND TOTAL OF SERVE ME
export const SHOW_ALL_TOTAL_AMOUNT = "SHOW_ALL_TOTAL_AMOUNT";
export const STORE_ALL_TOTAL_AMOUNT = "STORE_ALL_TOTAL_AMOUNT";
export const REMOVE_THE_TOTAL_AMOUNT = "REMOVE_THE_TOTAL_AMOUNT";
